import EventEmitter from 'helpers/event-emitter';
import { get } from 'lodash';

export type Toast = {
  title: string;
  actionMessage?: string;
  onActionPress?: () => void;
  duration?: number;
  type?: 'warning' | 'danger' | 'success';
  message?: string;
};

const show = (toast: Toast, delay = 0) =>
  setTimeout(() => {
    EventEmitter.trigger('toast', toast);
  }, delay);

const success = (
  title: string,
  actionMessage?: string,
  onActionPress?: () => void,
  duration?: number,
  delay?: number,
) => {
  show({ title, actionMessage, onActionPress, duration }, delay);
};

const warning = (err: string, delay?: number) => {
  show(
    {
      type: 'warning',
      title: 'Heads Up!',
      message: get(err, 'message', err),
      duration: 60,
    },
    delay,
  );
};

const error = (err: string, delay?: number) => {
  show(
    {
      type: 'danger',
      title: get(err, 'title', 'Heads Up!'),
      message: get(err, 'message', err),
      duration: 60,
    },
    delay,
  );
};

export default { show, error, success, warning };
